var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5303 0.469665C19.7229 0.662248 19.796 0.944107 19.7212 1.206L14.58 19.206C14.4928 19.5112 14.223 19.7284 13.9063 19.7485C13.5896 19.7686 13.2945 19.5872 13.1695 19.2955L9.43001 10.5712L0.704602 6.83225C0.412897 6.70725 0.231443 6.41218 0.25151 6.09545C0.271577 5.77873 0.48882 5.50892 0.793968 5.42173L18.794 0.278875C19.0559 0.204051 19.3377 0.277083 19.5303 0.469665ZM3.23454 6.28445L10.2966 9.31065C10.4736 9.3865 10.6146 9.52754 10.6905 9.70455L13.717 16.7655L17.9081 2.092L3.23454 6.28445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.11ba0a5aae254a3eebaa86932cb68f2b.svg";
export { ForwardRef as ReactComponent };